import { stylesheet } from 'typestyle';
import { colors, font } from '../../assets/styles';

const styles = stylesheet({
  contactList: {},
  emptyList: {
    marginTop: 20,
  },
  section1: {
    color: colors.black,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  sectionTitle: {
    fontWeight: font.weight.bold,
    fontSize: 16,
    textTransform: 'uppercase',
  }
});

export default styles;
